import { createAction } from 'redux-actions';

export const paymentsWithdrawBankwireRequest = createAction('PAYMENTS_WITHDRAW_BANKWIRE_REQUEST');
export const paymentsWithdrawBankwireSuccess = createAction('PAYMENTS_WITHDRAW_BANKWIRE_SUCCESS');
export const paymentsWithdrawBankwireFail = createAction('PAYMENTS_WITHDRAW_BANKWIRE_FAIL');

export const paymentsWithdrawHyperwalletRequest = createAction(
  'PAYMENTS_WITHDRAW_HYPERWALLET_REQUEST',
);
export const paymentsWithdrawHyperwalletSuccess = createAction(
  'PAYMENTS_WITHDRAW_HYPERWALLET_SUCCESS',
);
export const paymentsWithdrawHyperwalletFail = createAction('PAYMENTS_WITHDRAW_HYPERWALLET_FAIL');

export const initializeAccountReference = createAction('INITIALIZE_ACCOUNT_REFERENCE');
export const initializeChineseName = createAction('INITIALIZE_CHINESE_NAME');

export const clientConfirmWithdrawRequest = createAction('CLIENT_CONFIRM_WITHDRAW_REQUEST');
export const clientConfirmWithdrawSuccess = createAction('CLIENT_CONFIRM_WITHDRAW_SUCCESS');
export const clientConfirmWithdrawFail = createAction('CLIENT_CONFIRM_WITHDRAW_FAIL');

export const skrillWithdrawalRequest = createAction('SKRILL_WITHDRAWAL_REQUEST');
export const skrillWithdrawalSuccess = createAction('SKRILL_WITHDRAWAL_SUCCESS');
export const skrillWithdrawalFail = createAction('SKRILL_WITHDRAWAL_FAIL');

export const netellerWithdrawalRequest = createAction('NETELLER_WITHDRAWAL_REQUEST');
export const netellerWithdrawalSuccess = createAction('NETELLER_WITHDRAWAL_SUCCESS');
export const netellerWithdrawalFail = createAction('NETELLER_WITHDRAWAL_FAIL');

export const paypalWithdrawalRequest = createAction('PAYPAL_WITHDRAWAL_REQUEST');
export const paypalWithdrawalSuccess = createAction('PAYPAL_WITHDRAWAL_SUCCESS');
export const paypalWithdrawalFail = createAction('PAYPAL_WITHDRAWAL_FAIL');

export const perfectMoneyWithdrawalRequest = createAction('PERFECT_MONEY_WITHDRAWAL_REQUEST');
export const perfectMoneyWithdrawalSuccess = createAction('PERFECT_MONEY_WITHDRAWAL_SUCCESS');
export const perfectMoneyWithdrawalFail = createAction('PERFECT_MONEY_WITHDRAWAL_FAIL');

export const mifinityWithdrawalRequest = createAction('MIFINITY_WITHDRAWAL_REQUEST');
export const mifinityWithdrawalSuccess = createAction('MIFINITY_WITHDRAWAL_SUCCESS');
export const mifinityWithdrawalFail = createAction('MIFINITY_WITHDRAWAL_FAIL');

export const jetonWithdrawalRequest = createAction('JETON_WITHDRAWAL_REQUEST');
export const jetonWithdrawalSuccess = createAction('JETON_WITHDRAWAL_SUCCESS');
export const jetonWithdrawalFail = createAction('JETON_WITHDRAWAL_FAIL');

export const currencyCloudWithdrawalRequest = createAction('CURRENCY_CLOUD_WITHDRAWAL_REQUEST');
export const currencyCloudWithdrawalSuccess = createAction('CURRENCY_CLOUD_WITHDRAWAL_SUCCESS');
export const currencyCloudWithdrawalFail = createAction('CURRENCY_CLOUD_WITHDRAWAL_FAIL');

export const bvnkWithdrawalRequest = createAction('BVNK_WITHDRAWAL_REQUEST');
export const bvnkWithdrawalSuccess = createAction('BVNK_WITHDRAWAL_SUCCESS');
export const bvnkWithdrawalFail = createAction('BVNK_WITHDRAWAL_FAIL');

export const currencyCloudWithdrawalRequiredFieldsRequest = createAction(
  'CURRENCY_CLOUD_WITHDRAWAL_REQUIRED_FIELDS_REQUEST',
);
export const currencyCloudWithdrawalRequiredFieldsSuccess = createAction(
  'CURRENCY_CLOUD_WITHDRAWAL_REQUIRED_FIELDS_SUCCESS',
);
export const currencyCloudWithdrawalRequiredFieldsFail = createAction(
  'CURRENCY_CLOUD_WITHDRAWAL_REQUIRED_FIELDS_FAIL',
);
export const currencyCloudWithdrawalRequiredFieldsReset = createAction(
  'CURRENCY_CLOUD_WITHDRAWAL_REQUIRED_FIELDS_RESET',
);

export const currencyCloudWithdrawalConversionRateRequest = createAction(
  'CURRENCY_CLOUD_WITHDRAWAL_CONVERSION_RATE_REQUEST',
);
export const currencyCloudWithdrawalConversionRateSuccess = createAction(
  'CURRENCY_CLOUD_WITHDRAWAL_CONVERSION_RATE_SUCCESS',
);
export const currencyCloudWithdrawalConversionRateFail = createAction(
  'CURRENCY_CLOUD_WITHDRAWAL_CONVERSION_RATE_FAIL',
);
export const currencyCloudWithdrawalConversionRateReset = createAction(
  'CURRENCY_CLOUD_WITHDRAWAL_CONVERSION_RATE_RESET',
);
export const currencyConversionRatesReset = createAction('CURRENCY_CONVERSION_RATES_RESET');

export const interacETransferOutboundWithdrawalRequest = createAction(
  'INTERAC_E_TRANSFER_OUTBOUND_WITHDRAWAL_REQUEST',
);
export const interacETransferOutboundWithdrawalSuccess = createAction(
  'INTERAC_E_TRANSFER_OUTBOUND_WITHDRAWAL_SUCCESS',
);
export const interacETransferOutboundWithdrawalFail = createAction(
  'INTERAC_E_TRANSFER_OUTBOUND_WITHDRAWAL_FAIL',
);

export const paymentsWithdrawLocalBankwireRequest = createAction(
  'PAYMENTS_WITHDRAW_LOCAL_BANKWIRE_REQUEST',
);
export const paymentsWithdrawLocalBankwireSuccess = createAction(
  'PAYMENTS_WITHDRAW_LOCAL_BANKWIRE_SUCCESS',
);
export const paymentsWithdrawLocalBankwireFail = createAction(
  'PAYMENTS_WITHDRAW_LOCAL_BANKWIRE_FAIL',
);

export const paymentsWithdrawUnionpayBankwireRequest = createAction(
  'PAYMENTS_WITHDRAW_UNIONPAY_BANKWIRE_REQUEST',
);
export const paymentsWithdrawUnionpayBankwireSuccess = createAction(
  'PAYMENTS_WITHDRAW_UNIONPAY_BANKWIRE_SUCCESS',
);
export const paymentsWithdrawUnionpayBankwireFail = createAction(
  'PAYMENTS_WITHDRAW_UNIONPAY_BANKWIRE_FAIL',
);

export const currencyCalculatorRequest = createAction('CURRENCY_CALCULATOR_REQUEST');
export const currencyCalculatorSuccess = createAction('CURRENCY_CALCULATOR_SUCCESS');
export const currencyCalculatorFail = createAction('CURRENCY_CALCULATOR_FAIL');
export const currencyCalculatorReset = createAction('CURRENCY_CALCULATOR_RESET');

export const validateAddressRequest = createAction('VALIDATE_ADDRESS_REQUEST');
export const validateAddressSuccess = createAction('VALIDATE_ADDRESS_SUCCESS');
export const validateAddressFail = createAction('VALIDATE_ADDRESS_FAIL');

export const feeRequest = createAction('FEE_REQUEST');
export const feeSuccess = createAction('FEE_SUCCESS');
export const feeFail = createAction('FEE_FAIL');
export const cleanupFee = createAction('CLEANUP_FEE');

export const paymentsWithdrawFinraxRequest = createAction('PAYMENTS_WITHDRAW_FINRAX_REQUEST');
export const paymentsWithdrawFinraxSuccess = createAction('PAYMENTS_WITHDRAW_FINRAX_SUCCESS');
export const paymentsWithdrawFinraxFail = createAction('PAYMENTS_WITHDRAW_FINRAX_FAIL');

export const paymentsWithdrawDay1Request = createAction('PAYMENTS_WITHDRAW_DAY1_REQUEST');
export const paymentsWithdrawDay1Success = createAction('PAYMENTS_WITHDRAW_DAY1_SUCCESS');
export const paymentsWithdrawDay1Fail = createAction('PAYMENTS_WITHDRAW_DAY1_FAIL');

export const paymentsWithdrawDay1ValidateRequest = createAction(
  'PAYMENTS_WITHDRAW_DAY1_VALIDATE_REQUEST',
);
export const paymentsWithdrawDay1ValidateSuccess = createAction(
  'PAYMENTS_WITHDRAW_DAY1_VALIDATE_SUCCESS',
);
export const paymentsWithdrawDay1ValidateFail = createAction(
  'PAYMENTS_WITHDRAW_DAY1_VALIDATE_FAIL',
);

export const paymentsWithdrawDay1LimitRequest = createAction(
  'PAYMENTS_WITHDRAW_DAY1_LIMIT_REQUEST',
);
export const paymentsWithdrawDay1LimitSuccess = createAction(
  'PAYMENTS_WITHDRAW_DAY1_LIMIT_SUCCESS',
);
export const paymentsWithdrawDay1LimitFail = createAction('PAYMENTS_WITHDRAW_DAY1_LIMIT_FAIL');

export const paymentsWithdrawDay1FeeRequest = createAction('PAYMENTS_WITHDRAW_DAY1_FEE_REQUEST');
export const paymentsWithdrawDay1FeeSuccess = createAction('PAYMENTS_WITHDRAW_DAY1_FEE_SUCCESS');
export const paymentsWithdrawDay1FeeFail = createAction('PAYMENTS_WITHDRAW_DAY1_FEE_FAIL');
export const cleanupDay1Fee = createAction('CLEANUP_DAY1_FEE');

export const getCryptoDay1AssetsRequest = createAction('GET_CRYPTO_DAY1_ASSETS_REQUEST');
export const getCryptoDay1AssetsSuccess = createAction('GET_CRYPTO_DAY1_ASSETS_SUCCESS');
export const getCryptoDay1AssetsFail = createAction('GET_CRYPTO_DAY1_ASSETS_FAIL');

export const paymentsWithdrawAstropayRequest = createAction('PAYMENTS_WITHDRAW_ASTROPAY_REQUEST');
export const paymentsWithdrawAstropaySuccess = createAction('PAYMENTS_WITHDRAW_ASTROPAY_SUCCESS');
export const paymentsWithdrawAstropayFail = createAction('PAYMENTS_WITHDRAW_ASTROPAY_FAIL');

export const paymentsWithdrawDragonpayRequest = createAction('PAYMENTS_WITHDRAW_DRAGONPAY_REQUEST');
export const paymentsWithdrawDragonpaySuccess = createAction('PAYMENTS_WITHDRAW_DRAGONPAY_SUCCESS');
export const paymentsWithdrawDragonpayFail = createAction('PAYMENTS_WITHDRAW_DRAGONPAY_FAIL');

export const payidWithdrawalRequest = createAction('PAYID_WITHDRAWAL_REQUEST');
export const payidWithdrawalSuccess = createAction('PAYID_WITHDRAWAL_SUCCESS');
export const payidWithdrawalFail = createAction('PAYID_WITHDRAWAL_FAIL');

export const getTransferDetailsRequest = createAction('GET_TRANSFER_DETAILS_REQUEST');
export const getTransferDetailsSuccess = createAction('GET_TRANSFER_DETAILS_SUCCESS');
export const getTransferDetailsFail = createAction('GET_TRANSFER_DETAILS_FAIL');
export const transferDetailsReset = createAction('GET_TRANSFER_DETAILS_RESET');

export const getAvailableLocalBanksRequest = createAction('GET_AVAILABLE_LOCAL_BANKS_REQUEST');
export const getAvailableLocalBanksSuccess = createAction('GET_AVAILABLE_LOCAL_BANKS_SUCCESS');
export const getAvailableLocalBanksFail = createAction('GET_AVAILABLE_LOCAL_BANKS_FAIL');

// export const requestHyperwalletStatusChangeRequest = createAction(
//   'REQUEST_HYPERWALLET_STATUS_CHANGE_REQUEST',
// );
// export const requestHyperwalletStatusChangeSuccess = createAction(
//   'REQUEST_HYPERWALLET_STATUS_CHANGE_SUCCESS',
// );
// export const requestHyperwalletStatusChangeFail = createAction(
//   'REQUEST_HYPERWALLET_STATUS_CHANGE_FAIL',
// );

export const setWithdrawalActiveStep = createAction('SET_WITHDRAWAL_ACTIVE_STEP');

export const getPaypalRefundsRequest = createAction('GET_PAYPAL_REFUNDS_REQUEST');
export const getPaypalRefundsSuccess = createAction('GET_PAYPAL_REFUNDS_SUCCESS');
export const getPaypalRefundsFail = createAction('GET_PAYPAL_REFUNDS_FAIL');

export const paypalRefundRequest = createAction('PAYPAL_REFUND_REQUEST');
export const paypalRefundSuccess = createAction('PAYPAL_REFUND_SUCCESS');
export const paypalRefundFail = createAction('PAYPAL_REFUND_FAIL');

export const unableToRefundRequest = createAction('UNABLE_TO_REFUND_REQUEST');
export const unableToRefundSuccess = createAction('UNABLE_TO_REFUND_SUCCESS');
export const unableToRefundFail = createAction('UNABLE_TO_REFUND_FAIL');

export const finishUnableToRefundRequestCreation = createAction(
  'FINISH_UNABLE_TO_REFUND_REQUEST_CREATION',
);

export const finishWithdrawal = createAction('FINISH_WITHDRAWAL');
